import { useTranslations } from 'next-intl';

import { UiKitButtonBase } from '@/fo/ui/kit/button/base';

import { styles } from './SuccessMessage.styles';

export interface SuccessMessageProps {
  onClick?: () => void;
}

export function SuccessMessage({ onClick }: SuccessMessageProps) {
  const slots = styles();

  const t = useTranslations('comment.form.success');

  const title = t('title');

  const description = t('description');

  return (
    <div className={slots.base()}>
      <h2 className={slots.title()}>{title}</h2>
      <p className={slots.description()}>{description}</p>
      <UiKitButtonBase
        className={slots.button()}
        onClick={onClick}
      >
        {t('button')}
      </UiKitButtonBase>
    </div>
  );
}
